<template>
    <div ref="root">
        <div
            class="imageslider__container module__container"
            v-bind:class="{ container__fluid: [1, 2, 3].includes(module.layout.type) }"
        >
            <div class="imageslider__inner module__inner">
                <div class="imageslider__inner--main module__inner--main">
                    <div
                        class="imageslider__slider module__slider"
                        v-if="items && Array.isArray(items) && items.length > 0"
                        ref="slider"
                        :disable-dragging="items.length <= 1"
                        :autoplay="!['auto'].includes(module.data.type)"
                        loop
                        v-bind:class="{ slider: true }"
                    >
                        <ul
                            class="imageslider__slider-items module__slider-items"
                            v-bind:class="{
                                'module__slider-items--auto-height imageslider__slider-items--auto-height': [
                                    'auto'
                                ].includes(module.data.type)
                            }"
                        >
                            <li
                                class="module__slider-item imageslider__item flex--wrap"
                                :data-slide-id="image__value.id"
                                v-for="(image__value, image__key) in items"
                                v-bind:key="image__key"
                                v-bind:class="{
                                    'border-color-highlighted': [2].includes(module.layout.type)
                                }"
                            >
                                <div
                                    class="imageslider__bg-image"
                                    v-if="
                                        image__value.data &&
                                            image__value.data.image &&
                                            image__value.data.image.id
                                    "
                                >
                                    <app-moduleimage
                                        :data="image__value.data.image"
                                        :tag="'div'"
                                        :is-blurred="true"
                                        :custom-class="
                                            'imageslider__moduleimage module__moduleimage'
                                        "
                                    ></app-moduleimage>
                                    <app-moduleimage
                                        v-if="!['auto'].includes(module.data.type)"
                                        :data="image__value.data.image"
                                        :tag="'div'"
                                        :custom-class="
                                            'imageslider__moduleimage module__moduleimage'
                                        "
                                    ></app-moduleimage>
                                    <app-moduleimage
                                        v-if="['auto'].includes(module.data.type)"
                                        :data="image__value.data.image"
                                        :tag="'img'"
                                        :img-opacity="true"
                                        :custom-class="
                                            'imageslider__moduleimage module__moduleimage'
                                        "
                                    ></app-moduleimage>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { toArray } from '@/helpers/utils';
import { mapGetters } from 'vuex';
import ModuleImage from '@/components/assorted/ModuleImage';
import { SliderMixin } from '@/mixins/SliderMixin';

export default {
    data() {
        return {};
    },
    components: {
        'app-moduleimage': ModuleImage
    },
    mixins: [SliderMixin],
    methods: {},
    computed: {
        ...mapGetters(['getPageUrlFromId']),
        items() {
            return toArray(this.module.data.slides)
                .filter((i) => i.visible)
                .sort((a, b) => a.pos - b.pos);
        }
    },
    props: {
        module: Object
    }
};
</script>
